module.exports = __webpack_public_path__ + "img/图片4.616ef159.png";